import Vue from 'vue';
import store from 'store';
import { mapGetters } from 'vuex';
import { i18n } from 'lib/i18n.js';

export default (el) =>
  new Vue({
    components: {
      modal: () => import('../modal/modal.vue'),
      gwp: () => import('../gwp/gwp.vue'),
    },
    el,
    store,
    i18n,
    data() {
      return {
        modalTitle: '',
        addText: '',
      };
    },
    computed: {
      ...mapGetters('global', ['currentModal']),
    },
  });
